<template>
  <div @click="open">
    <k-layout>
      <k-flex c2>
        <div style="height: 1em;">{{event.cached_start_time | format_time}}</div>
        <div style="height: 1em; color: var(--ks-font-color-secondary)">{{event.cached_end_time | format_time}}</div>
      </k-flex>
      <k-flex c10>
        <div style="height: 1em;">{{ title }}</div>
        <div style="height: 1em; color: var(--ks-font-color-secondary);">{{ subtitle }}</div>
      </k-flex>
    </k-layout>
  </div>
</template>

<script>
import datelib from '@/lib/date.js';
import EventModel from '@/models/event.js'

export default {
	props: ["event", "start", "end"],
 	filters: {
  	...datelib
  },
  data () {
    return {
      subtitle: ""
    }
  },
  created () {
    var self = this;
    EventModel.subtitle_cb(this.event, "", function(val) {
      self.subtitle = val;
    })
  },
  methods: {
  	open() {
      this.$router.push("/cloudrec/event/"+this.event.uuid+"?start="+this.start+"&end="+this.end);
  	}
  },
  computed: {
  	title () {
      return EventModel.title(this.event);
		}
	}
}
</script>